import React from "react";
import { ArrowRight, ShieldCheck } from "lucide-react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { PageHero, Section, PrimaryButton } from "@/components/ui-helpers";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import ProofStrip from "@/components/ProofStrip";
import { TRUST_ITEMS } from "@/data/content";

export default function TrustCenter() {
  return (
    <>
      <SEO title="Trust Center" description="Straight answers about who enters your home, damage handling, products, access, scope and exactly what you pay for." />
      <PageHero kicker="Trust Center" title="The answers that actually matter" subtitle="Honest answers to the questions our clients care about most — before you ever book.">
        <PrimaryButton to="/contact">Request a Quote <ArrowRight className="h-4 w-4" /></PrimaryButton>
      </PageHero>
      <Section>
        <div className="grid lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <Accordion type="single" collapsible defaultValue="item-0" className="space-y-3">
              {TRUST_ITEMS.map((t, i) => (
                <AccordionItem key={t.q} value={`item-${i}`} className="ascendia-card border-0 px-5">
                  <AccordionTrigger className="text-left text-white hover:no-underline py-4">{t.q}</AccordionTrigger>
                  <AccordionContent className="text-secondary pb-4">{t.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
          <div className="space-y-5">
            <div className="ascendia-card card-accent-top p-6">
              <ShieldCheck className="h-6 w-6 text-gold-soft" />
              <h3 className="mt-3 font-display text-lg font-semibold text-white">Our satisfaction policy</h3>
              <p className="mt-2 text-sm text-secondary">We perform a final quality inspection on every job. Any scope-related concern reported within the defined period will be assessed and addressed according to our policy — fairly and honestly.</p>
            </div>
            <ProofStrip />
          </div>
        </div>
      </Section>
    </>
  );
}
